/* Swipe Again — storefront behavior: calculator, FAQ, nav, tracking */
(function () {
  "use strict";
  function push(o) { window.dataLayer = window.dataLayer || []; window.dataLayer.push(o); }

  /* ---- gclid persistence (feeds the offline conversion import) ----
     Fallback for the inline passthrough in layout/theme.liquid — writes the
     SAME cookie it owns: `_sa_gclid`, holding the encoded pair string
     (gclid=…&gbraid=…&gad_source=…&gclsrc=…) that snippets/sa-chat.liquid
     reads back. Keep name, value format, and expiry in lockstep with it. */
  try {
    var p = new URLSearchParams(location.search);
    var g = p.get("gclid");
    if (g) {
      var val = "gclid=" + encodeURIComponent(g);
      ["gbraid", "gad_source", "gclsrc"].forEach(function (k) {
        var v = p.get(k);
        if (v) val += "&" + k + "=" + encodeURIComponent(v);
      });
      var d = new Date(); d.setDate(d.getDate() + 30);
      document.cookie = "_sa_gclid=" + encodeURIComponent(val) + ";expires=" + d.toUTCString() + ";path=/;domain=.swipeagain.com;SameSite=Lax";
    }
  } catch (e) {}

  /* ---- mobile nav ---- */
  document.addEventListener("click", function (e) {
    var b = e.target.closest(".sa-burger");
    if (b) { document.querySelector(".sa-nav").classList.toggle("open"); return; }
    var navA = e.target.closest(".sa-nav a");
    if (navA) document.querySelector(".sa-nav").classList.remove("open");
  });

  /* ---- FAQ accordion ---- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".sa-qa > button");
    if (!btn) return;
    var qa = btn.parentElement, ans = qa.querySelector(".sa-a"), open = qa.classList.toggle("open");
    ans.style.maxHeight = open ? ans.scrollHeight + "px" : "0px";
  });

  /* ---- pricing toggle ---- */
  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-sa-bill]");
    if (!t) return;
    var card = t.closest(".sa-price-card");
    card.querySelectorAll("[data-sa-bill]").forEach(function (x) { x.classList.remove("on"); });
    t.classList.add("on");
    var annual = t.getAttribute("data-sa-bill") === "annual";
    card.querySelector("[data-sa-price]").innerHTML = annual ? "<span style=\"display:block;font:500 22px var(--sa-font-b);color:var(--sa-muted)\"><s>$2,148</s></span>$1,799<small>/yr</small>" : "$179<small>/mo</small>";
    card.querySelector("[data-sa-per]").textContent = annual
      ? "Billed annually — save $349 vs monthly. Cancel anytime."
      : "Billed monthly. Cancel anytime.";
    /* The CTA href is NEVER rewritten: it always keeps its server-rendered
       target ({{ settings.app_url }}/signup = app.swipeagain.com/signup),
       including any click IDs the gclid passthrough appended to it. There
       is no Shopify product behind this plan — billing happens in the app,
       where the interval is chosen. (A previous version rewrote the href to
       /products/swipe-again-monthly, which 404s.) */
  });

  /* ---- revenue calculator ---- */
  var rev = document.getElementById("sa-rev");
  if (rev) {
    var fired = false;
    var fmt$ = function (n) {
      return "$" + Math.round(n).toLocaleString("en-US");
    };
    var update = function () {
      var r = Number(rev.value);
      var lostMo = r * 0.075, recMo = lostMo * 0.40;
      document.getElementById("sa-rev-out").textContent = fmt$(r);
      document.getElementById("sa-lost").textContent = fmt$(lostMo);
      document.getElementById("sa-rec").textContent = fmt$(recMo);
      document.getElementById("sa-rec-yr").textContent = fmt$(recMo * 12);
      if (!fired) {
        fired = true;
        push({ event: "calculator_used", calculator_revenue: r,
               estimated_recovered_annual: Math.round(recMo * 12) });
      }
    };
    rev.addEventListener("input", update);
    update();
  }

  /* ---- CTA + pricing view tracking ---- */
  document.addEventListener("click", function (e) {
    var a = e.target.closest("a");
    if (!a) return;
    var txt = (a.textContent || "").trim().toLowerCase();
    if (txt.indexOf("start my free trial") !== -1 || txt.indexOf("recover mine") !== -1) {
      push({ event: "signup_cta_click", cta_text: txt, cta_href: a.getAttribute("href") });
    }
  }, { passive: true });
  var pv = document.querySelector(".sa-price-card"), pvFired = false;
  if (pv && "IntersectionObserver" in window) {
    new IntersectionObserver(function (es, io) {
      es.forEach(function (en) {
        if (en.isIntersecting && !pvFired) { pvFired = true; push({ event: "pricing_viewed" }); io.disconnect(); }
      });
    }, { threshold: 0.4 }).observe(pv);
  }

  /* ---- scroll reveal ---- */
  if ("IntersectionObserver" in window) {
    var io2 = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("in"); io2.unobserve(en.target); } });
    }, { threshold: 0.12 });
    document.querySelectorAll(".sa-rev").forEach(function (el) { io2.observe(el); });
  } else {
    document.querySelectorAll(".sa-rev").forEach(function (el) { el.classList.add("in"); });
  }
})();
